<template>
  <div>
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="套卷状态">
        <Select v-model="searchCondition.is_release" style="width:200px;" clearable>
          <Option v-for="(item, index) in paperStatus" :key="index" :value="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="套卷名称">
        <Input
          v-model="searchCondition.name"
          placeholder="请输入套卷名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button
        type="primary"
        :to="{name: 'QuestionPaperPackageChoose'}"
        style="margin-right:50px;"
      >发布新套卷</Button>
      <Checkbox v-model="onlyShowMe" @on-change="onMineChange">只看我创建的</Checkbox>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/exam/packagePractice"
        :search="searchCondition"
        @onSelectionChange="onSelectionChange"
        :rowsFormatter="rowsFormatter"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button
              type="text"
              size="small"
              :to="{name:'QuestionPaperPackageDetail', query:{id: row.id, type: 1}}"
            >详情</Button>
            <span>-</span>
            <Button type="text" size="small" v-if="row.is_release == 3">撤回中</Button>
            <Button
              type="text"
              size="small"
              v-else
              @click="onForbidden(row.is_release != 1 ? 1 : 2, row.id)"
            >{{row.is_release == 1 ? '撤回' : '发布'}}</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button class="btn-margin-right" size="small" @click="onForbidden(1)">发布</Button>
          <Button class="btn-margin-right" size="small" @click="onForbidden(2)">撤回</Button>
          <Button class="btn-margin-right" size="small" @click="onForbidden(3)">删除</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
import { QuestionPaperPackageStatus, QuestionPaperType } from "@/utils/enums";
export default {
  name: "question-paper-manager",
  data() {
    return {
      paperStatus: QuestionPaperPackageStatus.getOptions(),
      searchCondition: {
        is_release: "",
        name: "",
        only_me: "",
        init: function() {
          this.is_release = "";
          this.name = "";
        }
      },
      onlyShowMe: false,
      tableColumns: [
        { title: "套卷名称", key: "name", minWidth: 180 },
        { title: "关联试卷名", key: "exam_name", minWidth: 180 },
        { title: "试卷类型", key: "exam_type_name", minWidth: 100 },
        { title: "状态", key: "is_release_name", minWidth: 100 },
        { title: "创建人", key: "creator", minWidth: 100 },
        { title: "更新时间", key: "updated_at", minWidth: 160 },
        { title: "操作", slot: "action", fixed: "right", minWidth: 120 }
      ],
      selectItems: []
    };
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(item => {
        item.exam_type_name = QuestionPaperType.getValue(item.exam_type);
        item.is_release_name =
          item.is_release == 1
            ? "发布"
            : item.is_release == 2
            ? "撤回"
            : "撤回中";
        item.updated_at = this.$pub.timestampToTime(item.updated_at);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.init();
      } else {
        this.searchCondition.only_me = this.onlyShowMe ? 1 : "";
      }
      this.$refs.grid.searchRefresh();
    },
    async onMineChange() {
      await this.search(1);
    },
    onSelectionChange(items) {
      this.selectItems = items;
    },
    /**
     * @param {Number} type   1 发布 2撤回 3删除
     * @param {String} id    试卷id
     */
    onForbidden(type, id) {
      if (type == 2) {
        this.$promiseConfirm(
          "撤回将在今日24点生效，届时该套卷将从前台【套卷练习】首页消失，已做过的学员可在『我的测评』中查看该套卷的练习历史和详情，是否确认撤回？",
          "撤回"
        ).then(() => {
          this.nextAction(type, id);
        });
      } else if (type == 3) {
        this.$Modal.confirm({
          title: "提示",
          content: "<p>确定要删除该试卷吗？</p>",
          onOk: () => {
            this.nextAction(type, id);
          }
        });
      } else {
        this.nextAction(type, id);
      }
    },
    nextAction(type, id) {
      let ids = "";
      if (id) {
        ids = id;
      } else {
        this.selectItems.forEach(item => {
          ids += item.id + ",";
        });
        ids = ids.substr(0, ids.length - 1);
      }
      if (type == 3) {
        // 多选删除
        this.$http.delete("/api/exam/packagePractice/" + ids).then(() => {
          this.$Message.deleteSuccess();
          this.search(1);
        });
      } else {
        // 撤回/发布接口
        this.$http
          .post(`/api/exam/packagePractice/release`, {
            id: ids,
            is_release: type == 1 ? 1 : 3
          })
          .then(() => {
            this.$Message.success(type == 1 ? "发布成功" : "撤回成功");
            this.search(1);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  .modal-item {
    border: 1px solid #eee;
    width: 180px;
    padding: 20px;
    cursor: pointer;
    .modal-item-title {
      text-align: center;
      margin-bottom: 10px;
    }
  }
}
</style>